import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '574px'
  },

  attributes: {
    marginTop: '25px'
  },
  buttons: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    marginTop: '25px'
  }
}));

export default useStyles;
